import type { DigitalCardProfileItem } from "./digital-cards.interface";

export function defaultDigitalCardProfileId(
  templates: DigitalCardProfileItem[],
): string | null {
  if (templates.length === 0) {
    return null;
  }
  const preferred =
    templates.find((template) => template.isDefault) ?? templates[0];
  const profileId = preferred.profileId?.trim();
  return profileId && profileId.length > 0 ? profileId : null;
}
